import {AxiosResponse} from 'axios';
import {gateway} from '../config/api';
import {ProductSearchExtendProps, SearchResultsProps} from '../types/types';

interface searchBooksResponseType extends AxiosResponse {
  data: SearchResultsProps;
}

interface searchBooksByIdResponseType extends AxiosResponse {
  data: ProductSearchExtendProps;
}

async function searchBooks(
  keyword: string,
  page: number,
  size: number,
): Promise<SearchResultsProps> {
  const res: searchBooksResponseType = await gateway().get(
    `/books/search/byText?keyword=${keyword}&weight=1000&page=${page}&size=${size}`,
  );

  const {data} = res;

  if (res.status === 200) {
    return data;
  }
  return Promise.reject('Sorry, something went wrong');
}

async function getBookById(id: string): Promise<ProductSearchExtendProps> {
  const res: searchBooksByIdResponseType = await gateway().get(`/books/${id}`);

  const {data} = res;

  if (res.status === 200) {
    return data;
  }
  return Promise.reject('Sorry, something went wrong');
}

export default {
  getBookById,
  searchBooks,
};
